d<template>
  <div>
    <b-btn-group v-if="canEdit && !item._editing">
      <b-btn class="save-row-toggle" v-if="canEdit" @click="startEditItem(item)" size="xs" variant="secondary" :disabled="item._saving">
        <i class="fas fa-edit" />
      </b-btn>
      <b-btn v-if="canEdit" @click="deleteItem(item)" size="xs" variant="danger" :disabled="item._saving">
        <i v-if="!item._deleting" class="fas fa-trash" />
        <b-spinner v-if="item._deleting" small variant="light"></b-spinner>
      </b-btn>
    </b-btn-group>
    <b-btn-group v-if="canEdit && item._editing">
      <b-btn class="save-row-toggle" v-if="canEdit" @click="finishEditItem(item)" size="xs" variant="primary" :disabled="item._saving">
        <i v-if="!item._saving" class="fas fa-save" />
        <b-spinner v-if="item._saving" small variant="light"></b-spinner>
      </b-btn>
      <b-btn v-if="canEdit" @click="cancelEditItem(item)" size="xs" variant="outline-danger" :disabled="item._saving">
        <i class="fas fa-times" />
      </b-btn>
    </b-btn-group>
  </div>
</template>

<script>
const axios = require('axios')

export default {
  props: ['items', 'item', 'apiUrl', 'canEdit'],
  data() {
    return {
    }
  },
  methods: {
    startEditItem(item) {
      this.$set(item, '_editing', true)
      this.$set(item, '_new_amount_available', item.amount_available)
    },
    cancelEditItem(item) {
      this.$set(item, '_editing', false)
      this.$set(item, '_new_amount_available', null)
      if (typeof item.id === 'undefined' || !item.id) {
        this.deleteItem(item)
      }
    },
    finishEditItem(item) {
      this.$set(item, '_saving', true)
      console.log("finish edit", item)
      if (typeof item.id === 'undefined' || !item.id) {
        axios.post(this.apiUrl, {
          ingredient_id: item.ingredient_id,
          amount_available: item._new_amount_available,
        }).then((result) => {
          this.$set(item, 'id', result.data.id)
          this.$set(item, 'amount_available', result.data.amount_available)
          this.$set(item, '_saving', false)
          this.$set(item, '_editing', false)
          this.$set(item, '_new_amount_available', null)
        }).catch(error => {
          this.$set(item, '_saving', false)
        })
      } else {
        axios.put(this.apiUrl, {
          amount_available: item._new_amount_available,
        }, {
          params: {
            id: item.id,
          }
        }).then((result) => {
          this.$set(item, 'amount_available', result.data.amount_available)
          this.$set(item, '_saving', false)
          this.$set(item, '_editing', false)
          this.$set(item, '_new_amount_available', null)
        }).catch(error => {
          this.$set(item, '_saving', false)
        })
      }
    },
    deleteItem(item) {
      if (typeof item.id === 'undefined' || !item.id) {
        this.$set(item, '_deleting', false)
        this.$set(item, '_saving', false)
        const index = this.items.indexOf(item)
        this.items.splice(index, 1)
      } else {
        this.$set(item, '_deleting', true)
        this.$set(item, '_saving', true)
        axios.delete(this.apiUrl, {
          params: {
            id: item.id,
          }
        }).then((result) => {
          if (result.data.deleted) {
            const index = this.items.indexOf(item)
            // item may hav already been deleted by pusher
            if (index >= 0) {
              this.items.splice(index, 1)
            }
          } else {
            this.$set(item, '_deleting', false)
            this.$set(item, '_saving', false)
          }
        }).catch(error => {
          this.$set(item, '_deleting', false)
          this.$set(item, '_saving', false)
        })
      }
    },
  }
}
</script>

<style scoped>

</style>